/**
 * Parse a feature's `settings` field into an array.
 *
 * The API stores `settings` as a JSON-encoded string. A historic save bug
 * double-encoded some rows (the value was stringified twice), so a single
 * `JSON.parse` can still return a string. This helper unwraps up to a few
 * levels of encoding and falls back to an empty array on malformed data —
 * decoding legacy rows losslessly without ever throwing.
 *
 * @param {unknown} raw - The raw `settings` value from the API (string, array or nullish).
 * @returns {Array} The decoded settings array (empty on failure).
 */
export const parseFeatureSettings = (raw) => {
  let value = raw;
  for (let i = 0; i < 3 && typeof value === 'string'; i += 1) {
    try {
      value = JSON.parse(value);
    } catch {
      return [];
    }
  }
  return Array.isArray(value) ? value : [];
};
